import React from "react";
import { Grid, Typography, useTheme,Box } from "@mui/material";
import MainTitle from "../home/MainTitle";

import InexButton from "../InexButton";

import imageEvent from "../../resources/images/png/events/img.png";

const EventPresentation = ({ event }) => {
	const theme = useTheme();

	return (
		<Grid container p={3}>
			<Grid item xs={12} mb={5}>
				<MainTitle
					title={"Présentation de l'évènement"}
					typoProps={{
						applyTransform: false,
						underlineColor: theme.palette.primary.main,
						sx: {
							color: "white",
						},
					}}
				/>
			</Grid>
			<Grid
				container
				item
				xs={12}
				spacing={4}
				sx={{
					display: "flex",
					alignItems: "center",
				}}
			>
				<Grid item xs={12} md={8} mb={5}>
					<Typography
						dangerouslySetInnerHTML={{ __html: event.presentation }}
						sx={{
							fontSize: 18,
							fontFamily: "Branding Medium",
							color: "white",
							"& a":{
								color: "white"
							},
							"& strong":{
								fontWeight: "bold"
							},
							"& em":{
								fontStyle: "italic"
							},
						}}
					/>

				<a href={"https://praticiens.inexplore.com"}>
					<InexButton
						textWithGradient={false}
						disableBackground={true}
						text={"Inexploré Praticiens : découvrir le projet"}
						sx={{
							marginTop: 4,
							padding: 3.5,
							backgroundColor: (theme) => theme.palette.lightgrey,
							transition: "border-color 0.3s, background 0.3s, color 0.3s,",
							"& > p": {
								color: (theme) => theme.palette.secondary.main,
								transition: "color 0.3s,",
							},
							"&:hover": {
								backgroundColor: "white",
								border: "none",
							},
						}}
					/>
				</a>
				</Grid>
				<Grid
					item
					xs={12}
					md={4}
					mb={5}
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<img
						src={`https://medias.inrees.com/img/agenda/depliable_${event?.id}.jpg`}
						alt={"imageEvent"}
						style={{ width: "100%", objectFit: "contain", maxWidth: "350px" }}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default EventPresentation;
